import { Routes } from '../../routes';
import { useIntl } from 'react-intl';
import { useUser } from '../../hooks/user';
import WikusPageLayout from '@wikus-ui/components/PageLayout';

export function AdminHomeLayout({ children }: any) {
  const user = useUser();
  const intl = useIntl();

  const navigationUrls = user.role === 'A' ? [{
    label: intl.formatMessage({ id: 'navigation.customers' }),
    url: Routes.customers,
  }, {
    label: intl.formatMessage({ id: 'navigation.admins' }),
    url: Routes.admins,
  }] : undefined;

  return <WikusPageLayout
    canGoToHome={true}
    userName={`${user.firstName} ${user.lastName}`}
    userRole={intl.formatMessage({ id: `roles.${user.role}` })}
    title={intl.formatMessage({ id: 'customers' })}
    heroWithImage={true}
    navigationUrls={navigationUrls}
  >{children}</WikusPageLayout>
}